// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1n98m","approved":"Status_approved__17tKJ","rejected":"Status_rejected__2qv9V","expired":"Status_expired__1yN3P","label":"Status_label__32C8D"};